module.exports = __webpack_public_path__ + "static/blotTest-6e35141998a62c3b918ba8b57970f8c1.jpg";